import { UserRole } from '%__generated__/types';
import { useDebounce } from './useDebounce';
import { useSearchUsersQuery } from './graphql/__generated__/searchUsers.generated';

export const useMyConnectionsSearch = ({
	search,
	role,
	restricted,
}: {
	search: string;
	role?: UserRole;
	restricted?: boolean;
}) => {
	const debouncedSearch = useDebounce(search);
	const { data, loading, error, refetch } = useSearchUsersQuery({
		variables: {
			search: debouncedSearch,
			role,
			restricted,
		},
	});

	return { data: data?.searchUsers || [], loading, error, refetch };
};
